export default __webpack_public_path__ + "static/media/print_bill_1.959372cc.svg";